import { get } from 'lodash'

export default function(fields, lastPersonalReflection) {
  return {
    ...fields,
    personalReflection: get(lastPersonalReflection, 'personalReflection') || get(fields, 'personalReflection'),
    helpers: undefined
  }
}
